import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers-pro";
import AsyncButton from "@components/AsyncButton";
import SankeyChart from "@components/visualizations/SankeyChart";
import moment from "moment";
import AdvertiserContext from "@components/AdvertiserContext";
import useGetSankeyData from "@components/hooks/apis/sankeyData";

const ReportsSankey = () => {
  const adContext = useContext(AdvertiserContext);

  const [minStartDate] = useState(moment().subtract(90, "days"));
  const [selectedStartDate, setSelectedStartDate] = useState(moment().subtract(30, "days"));
  const [selectedEndDate, setSelectedEndDate] = useState(moment());
  const [dateFilters, setDateFilters] = useState({
    startDate: selectedStartDate,
    endDate: selectedEndDate,
  });

  const { data: dashboardData, isLoading, mutate } = useGetSankeyData(dateFilters);

  const handleUpdateStartDate = (date: moment.Moment | null) => {
    setSelectedStartDate(date ?? moment.invalid());
  };

  const handleUpdateEndDate = (date: moment.Moment | null) => {
    setSelectedEndDate(date ?? moment.invalid());
  };

  const handleButtonClick = () => {
    if (selectedStartDate.isValid() && selectedEndDate.isValid()) {
      setDateFilters({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
      });
    }
  };

  useEffect(() => {
    if (isLoading) return;
    mutate();
  }, [adContext.id]);

  return (
    <Box width="100%">
      <Box display="flex" marginBottom="8px">
        <DatePicker
          disableFuture
          label="Start Date"
          data-testid="start-date-picker"
          minDate={minStartDate}
          maxDate={selectedEndDate}
          onChange={handleUpdateStartDate}
          value={selectedStartDate}
        />
        <DatePicker
          sx={{ marginLeft: '10px' }}
          disableFuture
          label="End Date"
          data-testid="end-date-picker"
          minDate={selectedStartDate}
          onChange={handleUpdateEndDate}
          value={selectedEndDate}
        />
        <AsyncButton
          isLoading={isLoading}
          variant="contained"
          size="medium"
          sx={{
            fontSize: '16px',
            minWidth: '160px',
            height: '48px',
          }}
          onClick={handleButtonClick}
          loadingButton="Loading..."
        >
          Filter
        </AsyncButton>
      </Box>
      {!isLoading && dashboardData ? (
        <SankeyChart data={dashboardData} />
      ) : (
        <p>loading...</p>
      )}
    </Box>
  );
};

export default ReportsSankey;
